module.exports = __webpack_public_path__ + "media/images/products/retailers-product-2-grumpus-71e682e732faa88f40a63f61a558700b.jpg";